<template>
  <div class="flex flex-col container mx-auto">
    <div class="flex flex-row px-4 items-end justify-between relative">
      <div class="relative -bottom-2">
        <ProgramLogo :program="program" :size="48" />
      </div>
    </div>
    <base-card class="card bg-white z-10 flex flex-col p-2">
      <span>{{ program.name }}</span>
      <button
        class="text-end self-end text-sm mt-2 text-primary"
        @click="$emit('click', setting)"
      >
        Voir le document
      </button>
    </base-card>
  </div>
</template>

<script lang="ts" setup>
import {SupportProgramConsumerSettings} from "@/program/interfaces/Program";
import {computed} from "vue";
import ProgramLogo from "@/program/components/program-logo/ProgramLogo.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";

const props = defineProps<{
  setting: SupportProgramConsumerSettings;
}>();

defineEmits<{
  (e: 'click', setting: SupportProgramConsumerSettings): void;
}>();

const program = computed(() => props.setting.support_program.program);
</script>
